const cards = [
  {
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20evening%20cityscape%20with%20silhouetted%20figure%20walking%20through%20paparazzi%20flash%20lights%2C%20mysterious%20atmosphere%2C%20cinematic%20lighting%20with%20warm%20amber%20and%20deep%20crimson%20tones%2C%20entertainment%20news%20vibe%2C%20no%20visible%20faces%2C%20clean%20composition&width=800&height=600&seq=card-gossip-01&orientation=landscape',
    tag: '独家爆料',
    title: '某顶流深夜密会神秘女，细节令人震惊',
    excerpt: '据知情人士透露，某当红男星近日深夜被拍到与一名神秘女子同行，双方举止亲密引发热议。',
    time: '2小时前',
    views: '128.6万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Film%20set%20behind%20the%20scenes%20with%20director%20chair%20and%20camera%20equipment%2C%20dramatic%20lighting%20contrast%2C%20slightly%20chaotic%20atmosphere%2C%20warm%20golden%20hour%20tones%2C%20editorial%20photography%20style%2C%20clean%20composition%20with%20negative%20space&width=800&height=600&seq=card-gossip-02&orientation=landscape',
    tag: '现场直击',
    title: '知名导演被曝片场耍大牌，剧组人员集体不满',
    excerpt: '某知名导演在拍摄现场频繁发脾气辱骂工作人员，导致多名剧组核心成员中途退出。',
    time: '5小时前',
    views: '96.3万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Television%20studio%20set%20with%20bright%20stage%20lights%20and%20audience%20seats%2C%20dramatic%20moment%20frozen%20in%20time%2C%20warm%20theatrical%20lighting%2C%20slight%20tension%20in%20the%20air%2C%20editorial%20photography%2C%20clean%20composition&width=800&height=600&seq=card-gossip-03&orientation=landscape',
    tag: '突发新闻',
    title: '某综艺节目录制现场突发意外，导演紧急叫停',
    excerpt: '某热门综艺在最新一期录制过程中发生意外事件，现场一度混乱，嘉宾表情十分尴尬。',
    time: '8小时前',
    views: '215.8万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Modern%20streaming%20studio%20with%20ring%20light%20and%20product%20display%20setup%2C%20minimalist%20background%2C%20warm%20neutral%20tones%2C%20slightly%20tense%20mood%2C%20editorial%20style%20photography%2C%20clean%20composition%20with%20negative%20space&width=800&height=600&seq=card-gossip-04&orientation=landscape',
    tag: '深度调查',
    title: '网红主播涉嫌虚假宣传被查，涉案金额惊人',
    excerpt: '某平台头部带货主播因涉嫌虚假宣传被相关部门立案调查，其直播间销售额累计超十亿。',
    time: '12小时前',
    views: '187.4万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Music%20recording%20studio%20with%20microphone%20and%20headphones%2C%20sheet%20music%20scattered%20on%20desk%2C%20dramatic%20side%20lighting%2C%20warm%20amber%20and%20shadow%20contrast%2C%20editorial%20photography%20style%2C%20clean%20composition&width=800&height=600&seq=card-gossip-05&orientation=landscape',
    tag: '争议追踪',
    title: '某歌手新歌被指抄袭国际大牌，旋律高度雷同',
    excerpt: '知名歌手发布的新单曲上线仅三小时便被网友扒出与国际知名乐队作品旋律高度相似。',
    time: '15小时前',
    views: '76.9万',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">最新爆料</h2>
          <p className="text-sm text-foreground-500">每日精选最热娱乐八卦，持续追踪争议事件</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.slice(0, 3).map((c, i) => (
            <article key={i} className="bg-background-100 rounded-lg overflow-hidden transition-all duration-200 hover:scale-[1.02] cursor-pointer group">
              <div className="relative aspect-[4/3] overflow-hidden bg-background-200">
                <img
                  src={c.image}
                  alt={c.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-semibold whitespace-nowrap">
                  {c.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base font-semibold text-foreground-900 mb-2 leading-snug line-clamp-2">{c.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-3 line-clamp-2">{c.excerpt}</p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{c.time}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {c.views}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {cards.slice(3).map((c, i) => (
            <article key={i + 3} className="bg-background-100 rounded-lg overflow-hidden transition-all duration-200 hover:scale-[1.01] cursor-pointer group flex flex-col sm:flex-row">
              <div className="relative sm:w-[200px] aspect-[4/3] sm:aspect-auto overflow-hidden bg-background-200 flex-shrink-0">
                <img
                  src={c.image}
                  alt={c.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-accent-500 text-background-50 text-xs font-semibold whitespace-nowrap">
                  {c.tag}
                </span>
              </div>
              <div className="p-4 flex-1 flex flex-col justify-center">
                <h3 className="text-base font-semibold text-foreground-900 mb-2 leading-snug">{c.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-3 line-clamp-2">{c.excerpt}</p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{c.time}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {c.views}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}